// Create or update a <meta name="...">
export function setMetaName(name, content) {
  if (!name) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  if (typeof content === "string" && content.trim() !== "") {
    el.setAttribute("content", content.trim());
  } else {
    el.parentNode && el.parentNode.removeChild(el);
  }
}

// Create or update a <meta property="og:...">
export function setMetaProperty(prop, content) {
  if (!prop) return;
  let el = document.querySelector(`meta[property="${prop}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", prop);
    document.head.appendChild(el);
  }
  if (typeof content === "string" && content.trim() !== "") {
    el.setAttribute("content", content.trim());
  } else {
    el.parentNode && el.parentNode.removeChild(el);
  }
}

// Set document title
export function setTitle(title) {
  if (typeof title === "string" && title.trim() !== "") {
    document.title = title.trim();
  }
}

// Set (or replace) favicon
export function setFavicon(href, type = "image/png") {
  if (!href) return;
  // remove existing favicons
  document.querySelectorAll('link[rel="icon"]').forEach((n) => n.remove());
  const link = document.createElement("link");
  link.setAttribute("rel", "icon");
  link.setAttribute("type", type);
  link.setAttribute("href", href);
  document.head.appendChild(link);
}
